import { Scissors, User, GraduationCap, HeartHandshake, Baby, Sparkles, Eye } from 'lucide-react'

const hairServices = [
  {
    icon: User,
    title: 'Herrklippning',
    duration: '30 min',
    price: '300 kr',
  },
  {
    icon: Scissors,
    title: 'Klippning + Skägg',
    duration: '60 min',
    price: '400 kr',
  },
  {
    icon: GraduationCap,
    title: 'Student Klippning (13-18 år)',
    duration: '30 min',
    price: '250 kr',
  },
  {
    icon: HeartHandshake,
    title: 'Pensionär Klippning + Skägg',
    duration: '45 min',
    price: '300 kr',
  },
  {
    icon: User,
    title: 'Pensionär Herrklippning',
    duration: '30 min',
    price: '250 kr',
  },
  {
    icon: Baby,
    title: 'Barn Klippning',
    duration: '30 min',
    price: '200 kr',
  },
]

const beardServices = [
  {
    icon: Sparkles,
    title: 'Skägg',
    duration: '30 min',
    price: '200 kr',
  },
  {
    icon: Scissors,
    title: 'Rakning',
    duration: '45 min',
    price: '250 kr',
  },
]

const hairRemoval = [
  {
    icon: Eye,
    title: 'Näs/Öron Vaxning',
    duration: '15 min',
    price: '50 kr',
  },
]

const staff = [
  {
    name: 'Valton',
    role: 'Barberare/Frisör',
    rating: '222 betyg',
  },
  {
    name: 'Robert',
    role: 'Elev',
  },
]

export default function Services() {
  return (
    <section id="tjanster" className="relative py-24 lg:py-32 bg-dark-900">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-0 left-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold-500/20 to-transparent" />
        <div className="absolute top-0 right-1/4 w-px h-full bg-gradient-to-b from-transparent via-gold-500/20 to-transparent" />
      </div>

      <div className="relative z-10 w-full px-4 sm:px-6 lg:px-12 xl:px-20">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="inline-block text-gold-400 font-semibold text-sm tracking-wider uppercase mb-4">
            Alla Tjänster
          </span>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
            Vårt <span className="text-gradient">utbud</span>
          </h2>
          <p className="text-gray-400 text-lg leading-relaxed">
            Professionella klippningar och skäggvård för alla åldrar till konkurrenskraftiga priser.
          </p>
        </div>

        {/* Hårklippning Section */}
        <div className="mb-12">
          <h3 className="font-display text-2xl font-semibold text-white mb-6 flex items-center gap-3">
            <Scissors className="w-6 h-6 text-gold-400" />
            Hårklippning
          </h3>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
            {hairServices.map((service) => (
              <div
                key={service.title}
                className="group relative p-6 rounded-2xl glass hover-lift"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-white text-lg">{service.title}</h4>
                  <service.icon className="w-5 h-5 text-gold-400" />
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">{service.duration}</span>
                  <span className="text-gold-400 font-semibold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Skägg & Rakning Section */}
        <div className="mb-12">
          <h3 className="font-display text-2xl font-semibold text-white mb-6 flex items-center gap-3">
            <Sparkles className="w-6 h-6 text-gold-400" />
            Skägg & Rakning
          </h3>
          <div className="grid md:grid-cols-2 gap-4 max-w-2xl">
            {beardServices.map((service) => (
              <div
                key={service.title}
                className="group relative p-6 rounded-2xl glass hover-lift"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-white text-lg">{service.title}</h4>
                  <service.icon className="w-5 h-5 text-gold-400" />
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">{service.duration}</span>
                  <span className="text-gold-400 font-semibold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Hårborttagning Section */}
        <div className="mb-16">
          <h3 className="font-display text-2xl font-semibold text-white mb-6 flex items-center gap-3">
            <Eye className="w-6 h-6 text-gold-400" />
            Hårborttagning
          </h3>
          <div className="grid md:grid-cols-2 gap-4 max-w-2xl">
            {hairRemoval.map((service) => (
              <div
                key={service.title}
                className="group relative p-6 rounded-2xl glass hover-lift"
              >
                <div className="flex items-center justify-between mb-2">
                  <h4 className="font-semibold text-white text-lg">{service.title}</h4>
                  <service.icon className="w-5 h-5 text-gold-400" />
                </div>
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-400">{service.duration}</span>
                  <span className="text-gold-400 font-semibold text-lg">{service.price}</span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Personal Section */}
        <div className="mb-12">
          <h3 className="font-display text-2xl font-semibold text-white mb-6 flex items-center gap-3">
            <User className="w-6 h-6 text-gold-400" />
            Personal
          </h3>
          <div className="grid md:grid-cols-2 gap-6 max-w-2xl">
            {staff.map((person) => (
              <div
                key={person.name}
                className="group relative p-6 rounded-2xl glass hover-lift flex items-center gap-4"
              >
                <div className="w-16 h-16 rounded-full bg-gradient-to-br from-gold-400 to-gold-600 flex items-center justify-center text-dark-900 font-bold text-xl">
                  {person.name.charAt(0)}
                </div>
                <div>
                  <h4 className="font-semibold text-white text-lg">{person.name}</h4>
                  <p className="text-gray-400">{person.role}</p>
                  {person.rating && (
                    <div className="flex items-center gap-1 mt-1">
                      <span className="text-gold-400 text-sm">★</span>
                      <span className="text-gold-400 text-sm">{person.rating}</span>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center">
          <a
            href="https://www.bokadirekt.se/places/vk-studio-54503"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-gold-500 to-gold-600 text-dark-900 font-bold rounded-full hover:from-gold-400 hover:to-gold-500 transition-all hover:scale-105 shadow-xl shadow-gold-500/25"
          >
            Boka tid
          </a>
        </div>
      </div>
    </section>
  )
}
